{
  "headings": {
    "login": "Log in",
    "forgotten": "Forgotten my password",
    "confirmation": "Email sent",
    "sending": "Email sending...",
    "setPass": "Set your password",
    "startYourFreeTrial": "Start your free trial."
  },
  "subHeadings": {
    "freeTrial": "30-day free trial. No credit-card required.",
    "login": "To access your Iventis account, start by entering your email address.",
    "forgotten": "Enter the email address linked to your Iventis account and we'll send you an email to reset your password.",
    "confirmation": "Check your email for a link to reset your password. It may take up to 10 mins to arrive.",
    "confirmationCode": "Check your email for a verification code for your new account. It may take up to 10 minutes to arrive.",
    "setPass": "Enter a new password for your account below."
  },
  "labels": {
    "firstName": "First name",
    "lastName": "Last name",
    "projectName": "Project Name",
    "email": "Email address",
    "password": "Password",
    "confirmPass": "Repeat password",
    "verificationCode": "Verification Code"
  },
  "placeholders": {
    "email": "Enter your email address",
    "password": "Enter your password",
    "passwordCreate": "Enter password",
    "passwordConfirm": "Type password again"
  },
  "links": {
    "signIn": "Sign In",
    "forgotPass": "Forgotten my password",
    "sendAgain": "Send again",
    "termsAndCo": "Terms and Conditions",
    "back": "Back",
    "register": "Register",
    "loginWithEmail": "Login with email instead",
    "loginWithSingleSignOn": "Login with Single Sign-on",
    "loginWithMicrosoft": "Login with your Microsoft account"
  },
  "options": {
    "alreadyHaveAccount": "Already have an Iventis account?",
    "dontHaveAccount": "Don't have a {{ ssoProviderName }} ?",
    "dontHaveIventis": "Don't have an Iventis account?",
    "rememberDetails": "Remember my details",
    "notReceived": "Not received an email?",
    "consentTos1": "In creating this account, I agree to the",
    "consentTos2": "of the Iventis platform.",
    "verified": "Code verified successfully! Your account is now active."
  },
  "passwordConditions": {
    "min8characters": "Minimum 8 characters",
    "lowercaseLetter": "Contains a lowercase letter",
    "uppercaseLetter": "Contains an uppercase letter",
    "digit": "Contains a number"
  },
  "buttons": {
    "continue": "Continue",
    "login": "Log in",
    "sendLink": "Send reset link",
    "createAccount": "Create account"
  },
  "footer": {
    "terms": "Terms of Service",
    "policy": "Privacy policy",
    "contact": "Contact us"
  },
  "error": {
    "invalidCode": "Invalid code.",
    "unknownError": "Something went wrong",
    "failed": "Failed to set password. Please try again.",
    "required": "Required",
    "invalid": "Invalid email address",
    "cantFindEmail": "We can't find an Iventis account linked to that email address. Try again, or create an account.",
    "passwordTooLong": "Password can be maximum 64 characters long",
    "passwordsMustMatch": "Passwords don't match",
    "mustAgreeToTC": "To create an account, you must accept our Terms and Conditions",
    "resetPasswordLinkInvalidTitle": "Link Expired",
    "resetPasswordLinkInvalid": "The link to reset your password was invalid or has expired. We have sent a new link to the email address associated with your account. If you do not receive a new link, try using the 'forgotten password' link below or contact",
    "emailInUse": {
      "0": "This email is already in use.",
      "1": "Click here",
      "2": "to login"
    }
  }
}